"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.constructor");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import goodsSelet from '@/components/goodsSelet/index.vue';
// import classifySelect from '@/components/classifySelect/index.vue';
// import groupSelect from '@/components/groupSelect/group.vue';
// import pagesSelet from './pages.vue';
// import liveSelect from './../liveSelect/index.vue';
// import miniProgramSelect from './module/mini-program.vue';
// import webLink from './module/web-link.vue';
var _default = {
  components: {
    // goodsSelet,
    // classifySelect,
    // groupSelect,
    // pagesSelet,
    // liveSelect,
    // miniProgramSelect,
    // webLink
  },
  inject: ['self'],
  data: function data() {
    return {
      searchData: '',
      cacheData: null,
      linkList: [{
        name: '店铺首页',
        path: '/pages/index/index',
        param: {},
        index: 0,
        extend: false
      }, {
        name: '全部商品',
        path: '/pages/goods/list',
        param: {},
        index: 1,
        extend: false
      }, {
        name: '单一商品',
        path: '/pages/goods/detail',
        param: {},
        index: 2,
        extend: true
      }, {
        name: '商品分类',
        path: '/pages/goods/search-list',
        param: {},
        index: 3,
        extend: true
      }, {
        name: '购物车',
        path: '/pages/cart/index',
        param: {},
        index: 4,
        extend: false
      }, {
        name: '个人中心',
        path: '/pages/user/index',
        param: {},
        index: 5,
        extend: false
      }, {
        name: '我的订单',
        path: '/pages/order/index',
        param: {},
        index: 6,
        extend: false
      }, {
        name: '微页面',
        path: '/pages/page/index',
        param: {},
        index: 7,
        extend: true
      }, {
        name: '所有分类',
        path: '/pages/categories/index',
        param: {},
        index: 8,
        extend: false
      }, {
        name: '直播间列表',
        path: '/pages/live/index',
        param: {},
        index: 9,
        extend: false
      }, {
        name: '直播间',
        path: '/pages/live/index',
        param: {},
        index: 10,
        extend: true
      }, {
        name: '其他小程序',
        path: '',
        param: {
          applet: {
            appId: '',
            path: '',
            label: 1
          },
          wechat: {
            appId: '',
            path: '',
            label: 1
          }
        },
        index: 11,
        extend: true
      }, {
        name: '自定义链接',
        path: '/pages/other/web',
        param: {
          url: ''
        },
        index: 12,
        extend: true
      }]
    };
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {
    'self.original': {
      handler: function handler(newData) {
        //特别注意，不能用箭头函数，箭头函数，this指向全局
        if (newData) {
          this.handlerDataUpdate();
        }
      },
      immediate: true,
      //刷新加载 立马触发一次handler
      deep: true // 可以深度检测到 obj 对象的属性值的变化
    },
    searchData: function searchData(value) {
      if (value == '') {
        this.linkList = JSON.parse(JSON.stringify(this.cacheData));
        this.self.selectData = null;
      }
    }
  },
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.cacheData = JSON.parse(JSON.stringify(this.linkList));
            this.handlerDataUpdate();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    /**
     * 处理选择器
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    handlerChange: function handlerChange(value) {},
    /**
     * 数据更新
     * @return {[type]} [description]
     */
    handlerDataUpdate: function handlerDataUpdate() {
      var original = this.self.original;
      for (var index in this.linkList) {
        var item = this.linkList[index];
        if (original.index == item.index) {
          this.linkList[index] = original;
        }
      }
      if (original) {
        this.self.selectData = original;
      }
    },
    hendleSearch: function hendleSearch() {
      var value = this.searchData;
      var simpleArr = this.linkList.filter(function (item) {
        var str = [''].concat((0, _toConsumableArray2.default)(value), ['']).join('.*'); //转化成正则格式的字符串
        var reg = new RegExp(str); //正则
        return reg.test(item.name); //去匹配待查询的字符串
      });

      this.linkList = simpleArr;
      for (var index in simpleArr) {
        var item = simpleArr[index];
        this.self.selectData = item;
        break;
      }
    }
  }
};
exports.default = _default;